var chunkMapping = {
	"2107": [
		2107
	],
	"2985": [
		2985
	],
	"3447": [
		3447
	],
	"3894": [
		3894
	],
	"4211": [
		4211
	],
	"5157": [
		5157
	],
	"5179": [
		5179
	],
	"5945": [
		5945
	],
	"7025": [
		7025
	],
	"8382": [
		8382
	],
	"9259": [
		9259
	],
	"9783": [
		2164
	]
};
var idToExternalAndNameMapping = {
	"2107": [
		"default",
		"./productCatalogs",
		3255
	],
	"2164": [
		"default",
		"./reports",
		6142
	],
	"2985": [
		"default",
		"./UserManagement",
		6616
	],
	"3447": [
		"default",
		"./my-profile",
		5642
	],
	"3894": [
		"default",
		"./videos",
		4386
	],
	"4211": [
		"default",
		"./footer",
		5410
	],
	"5157": [
		"default",
		"./order-history",
		5692
	],
	"5179": [
		"default",
		"./header",
		4402
	],
	"5945": [
		"default",
		"./cart",
		9180
	],
	"7025": [
		"default",
		"./products",
		2604
	],
	"8382": [
		"default",
		"./Admin",
		6616
	],
	"9259": [
		"default",
		"./help",
		4386
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}